import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

import closeIcon from 'resources/close_icon.png'
import Checkbox from 'material-ui/Checkbox'
import Utils from '../infra/Utils'
import Styles from '../common/Styles'
import ModulesUtils from 'infra/ModulesUtils'

const Actions = ({ onCancelClicked, onSendClicked }) => {
  return (
    <div style={styles.actions}>
      <FlatButton
        label='Cancel'
        onTouchTap={onCancelClicked}/>
      <FlatButton
        primary={true}
        label='Send'
        onTouchTap={onSendClicked}/>
    </div>
  )
}

Actions.propTypes = {
  onCancelClicked: PropTypes.func.isRequired,
  onSendClicked: PropTypes.func.isRequired
}

const Header = ({ billingEntity, onCloseRequested }) => {
  return (
    <div style={styles.header}>
      <div style={styles.heading}>
        Send { Utils.capitalize(billingEntity) }
      </div>
      <div style={{ marginRight: 16 }}>
        <img src={closeIcon} title='Close' width={16}
          onClick={onCloseRequested}
          style={{ cursor: 'pointer' }} />
      </div>
    </div>
  )
}

Header.propTypes = {
  onCloseRequested: PropTypes.func.isRequired,
  billingEntity: PropTypes.string.isRequired
}

class SendBillDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    billEditor: PropTypes.object,
    billingEntity: PropTypes.string.isRequired,
    teamName: PropTypes.string.isRequired,
    teamMembers: PropTypes.array.isRequired,
    userId: PropTypes.string.isRequired,
    onCloseRequested: PropTypes.func.isRequired,
    onSendBillClicked: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = this.mapPropsToState(this.props)
  }

  mapPropsToState = props => {
    if (props.billEditor) {
      const contactInfo = props.billEditor.getContactInfo()
      return {
        validationErrorField: null,
        input: {
          from: props.teamName,
          subject: `${Utils.capitalize(props.billingEntity)} #${props.billEditor.getNumber()} from ${props.teamName}`,
          message: '',
          replyTo: {
            name: ModulesUtils.getMemberName(this.props.teamMembers, this.props.userId),
            email: ModulesUtils.getMemberEmail(this.props.teamMembers, this.props.userId)
          },
          to: [ contactInfo && contactInfo.email || '' ],
          sendCopyToSelf: false,
          attachBillAsPDF: true
        }
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.open !== nextProps.open) {
      this.setState(this.mapPropsToState(nextProps))
    }
  }

  handleValueChanged = (key, value) => {
    this.setState({
      validationErrorField: null,
      input: Object.assign(this.state.input, {
        [key]: value
      })
    })
  }

  handleToClicked = index => {
    let to = this.state.input.to.slice()
    if (index) {
      to.splice(index, 1)
    }
    else {
      to.push('')
    }
    this.setState({
      validationErrorField: null,
      input: Object.assign(this.state.input, { to })
    })
  }

  handleToValueChanged = (index, value) => {
    const to = this.state.input.to.slice()
    to[index] = value
    this.setState({
      validationErrorField: null,
      input: Object.assign(this.state.input, { to })
    })
  }

  validateEmail = email => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email.toLowerCase())
  }

  validateInput = input => {
    if (!input.from) {
      return { errorField: 'from' }
    }
    if (input.to.every(email => !email)) {
      return { errorField: 'to' }
    }
    for (const email of input.to) {
      if (!this.validateEmail(email)) {
        return { errorField: 'to_invalid_addresses' }
      }
    }
    if (!input.subject) {
      return { errorField: 'subject' }
    }
    return { success: true }
  }

  handleSendClicked = () => {
    const validationResult = this.validateInput(this.state.input)
    if (!validationResult.success) {
      this.setState({
        validationErrorField: validationResult.errorField
      })
    }
    else {
      this.props.onSendBillClicked(this.state.input)
    }
  }

  handleSendCopyToSelfClicked = (event, checked) => {
    this.setState({
      validationErrorField: null,
      input: Object.assign(this.state.input, { sendCopyToSelf: checked })      
    })
  }

  handleAttachBillAsPdfClicked = (event, checked) => {
    this.setState({
      validationErrorField: null,
      input: Object.assign(this.state.input, { attachBillAsPDF: checked })      
    })
  }

  render() {
    if (!this.props.open) {
      return null
    }
    return (
      <Dialog open={this.props.open}
        onRequestClose={this.props.onCloseRequested}
        actions={
          <Actions
            onCancelClicked={this.props.onCloseRequested}
            onSendClicked={this.handleSendClicked} />
        }
        title={
          <Header
            billingEntity={this.props.billingEntity}
            onCloseRequested={this.props.onCloseRequested} />
        }
        bodyStyle={styles.dialogBody}
        contentStyle={styles.dialogContent}
        actionsContainerStyle={{ padding: 0 }}>
        <div style={styles.container}>
          <div style={styles.inputContainer}>
            <div style={Styles.fieldDisplay}>From</div>
            <input style={Styles.fieldInput}
              value={this.state.input.from}
              onChange={event => this.handleValueChanged('from', event.target.value)} />
            { this.state.validationErrorField === 'from' &&
              <div style={Styles.validationError}>* From field is required.</div>
            }
          </div>

          <div style={styles.inputContainer}>
            <div style={Styles.fieldDisplay}>To</div>
            { this.state.input.to.map((to, index) =>
              <div key={index} style={styles.toContainer(index)}>
                <input style={Styles.fieldInput}
                  value={this.state.input.to[index]}
                  onChange={event => this.handleToValueChanged(index, event.target.value)} />
                <i className='material-icons'
                  onClick={() => this.handleToClicked(index)}
                  style={{ marginLeft: 4, cursor: 'pointer' }}>
                  { index ? 'remove_circle' : 'add_circle' }
                </i>
              </div>
            )}
            { this.state.validationErrorField === 'to' &&
              <div style={Styles.validationError}>* Please enter at least one recipient address.</div>
            }
            { this.state.validationErrorField === 'to_invalid_addresses' &&
              <div style={Styles.validationError}>* One or more email addresses above are invalid.</div>
            }
          </div>

          <div style={styles.inputContainer}>
            <div style={Styles.fieldDisplay}>Subject</div>
            <input style={Styles.fieldInput}
              value={this.state.input.subject}
              onChange={event => this.handleValueChanged('subject', event.target.value)} />
            { this.state.validationErrorField === 'subject' &&
              <div style={Styles.validationError}>* Subject field is required.</div>
            }
          </div>

          <div style={styles.inputContainer}>
            <div style={Styles.fieldDisplay}>Message</div>
            <textarea style={Styles.textareaInput}
              rows={7}
              onChange={event => this.handleValueChanged('message', event.target.value)} />
            { this.state.validationErrorField === 'message' &&
              <div style={Styles.validationError}>* Message field is required.</div>
            }
          </div>

          <div style={styles.inputContainer}>
            {/* <Checkbox
              style={styles.optionCheckbox}
              iconStyle={styles.optionCheckboxIcon}
              checked={this.state.input.sendCopyToSelf}
              label={
                <div style={styles.option}>
                  <div>Send a copy to myself at</div>
                  <div style={{ fontStyle: 'italic', marginLeft: 4 }}>
                    { this.state.input.from }
                  </div>
                </div>
              }
              onCheck={this.handleSendCopyToSelfClicked} /> */}
            <Checkbox
              style={styles.optionCheckbox}
              iconStyle={styles.optionCheckboxIcon}
              disabled={true}
              checked={this.state.input.attachBillAsPDF}
              label={
                <div style={styles.option}>Attach the {this.props.billingEntity} as a PDF</div>
              }
              onCheck={this.handleAttachBillAsPdfClicked} />
          </div>
        </div>
      </Dialog>
    )
  }

}

const styles = {
  container: {
    marginTop: 16,
    marginBottom: 16,
    marginLeft: 32,
    marginRight: 32
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 16
  },
  toContainer: index => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: index ? 8 : 0
  }),
  option: {
    display: 'flex',
    flexDirection: 'row',
    color: '#494949',
    fontSize: 12
  },
  optionCheckbox: {
    marginBottom: 4
  },
  optionCheckboxIcon: {
    fill: '#359be0'
  },
  dialogContent: {
    borderRadius: 4,
    // This is a hack as there is a bug in Dialog's definition to properly
    // apply the border radius.
    overflow: 'auto',
    width: 400
  },
  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    borderRadius: 4
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 48,
    paddingRight: 16,
    backgroundColor: '#fafafa'
  },
  header: {
    display: 'flex',
    displayDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 48,
    backgroundColor: '#fafafa'
  },
  heading: {
    fontSize: 16,
    marginLeft: 16,
    color: '#212121'
  }
}

const mapStateToProps = state => ({
  teamName: state.firebase.team.metadata.value.displayName,
  teamMembers: state.firebase.team.members.value,
  userId: state.firebase.userAuth.id
})

export default connect(mapStateToProps)(SendBillDialog)



// WEBPACK FOOTER //
// ./src/billing/common/SendBillDialog.js